import { makeObservable, observable } from 'mobx';

export interface ILabOrderStatusModel {
  labOrderStatusId: number;
  name: string;
}

export class LabOrderStatusModel implements ILabOrderStatusModel {
  @observable labOrderStatusId: number;
  @observable name: string;

  constructor(
    params: Partial<ILabOrderStatusModel> = {} as LabOrderStatusModel,
  ) {
    const { labOrderStatusId = 0, name = '' } = params;

    this.labOrderStatusId = labOrderStatusId;
    this.name = name;

    makeObservable(this);
  }
}
